import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_TOURNAMENT } from '@/modules/tournament/router';
import { tournamentService } from '@/services/tournament';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useTournamentLeaderboardDetail() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        id: route.params.id,
        name: '',
        status: null,
        timeUnit: 0,
        timeDuration: null,
        publishTime: null,
        unpublishTime: null,
        canEdit: false,
        canDelete: false
    });

    const fetch = crudAction.executeAction({
        request: () => tournamentService.leaderboard.get(model.id),
        onSuccess: ({ data }) => Object.assign(model, data),
        onError: () => router.push({ name: ROUTE_NAME_TOURNAMENT.LEADERBOARD.INDEX })
    });

    const actions = {
        remove: crudAction.confirmAndRemove({
            request: () => tournamentService.leaderboard.remove(model.id),
            onSuccess: () => router.push({ name: ROUTE_NAME_TOURNAMENT.LEADERBOARD.INDEX })
        })
    };

    return { model, fetch, actions };
}
